import { render } from "./demo-login.vue?vue&type=template&id=b97ff09e&scoped=true&ts=true"
import script from "./demo-login.vue?vue&type=script&lang=ts"
export * from "./demo-login.vue?vue&type=script&lang=ts"

import "./demo-login.vue?vue&type=style&index=0&id=b97ff09e&lang=scss&scoped=true"

import exportComponent from "D:\\project\\haocai\\h5\\kousai-group\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b97ff09e"]])

export default __exports__